import { FetchChallansResponse, BaseReducerState, Challan } from '../../../services'
import { ActionTypes } from '../actions'

export type FetchChallanState = BaseReducerState & {
  data: Challan[]
}

const initialFetchChallanState: FetchChallanState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const fetchChallan = (
  state: FetchChallanState = initialFetchChallanState,
  action: { type: string; res: any }
): FetchChallanState => {
  switch (action.type) {
    case `${ActionTypes.FETCH_CHALLAN}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.FETCH_CHALLAN}_SUCCESS`: {
      const { success, data, message } = <FetchChallansResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.FETCH_CHALLAN}_FAILURE`: {
      const res = <FetchChallansResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }
    }

    case `${ActionTypes.FETCH_CHALLAN}_RESET`:
      return {
        ...initialFetchChallanState,
      }
  }
  return state
}
